module.exports = __webpack_public_path__ + "static/media/dolja.145039eb.mp3";